import { axiosInstance } from "./instance";

export const getSurveys = (id, uuid) => {
  return axiosInstance.get(`surveys/${id}?a=${uuid}`);
};

export const addSurveysResponse = (data) => {
    return axiosInstance.post(`surveys/response`, data);
  };
